import type { IconData, IconPickerI18n } from './icon-picker';

const CATEGORY_DE: Record<string, string> = {
  accessibility: 'Barrierefreiheit',
  account: 'Account',
  animals: 'Tiere',
  arrows: 'Pfeile',
  astronomy: 'Astronomie',
  automotive: 'Auto',
  brands: 'Marken',
  buildings: 'Gebäude',
  charts: 'Charts',
  communication: 'Kommunikation',
  connectivity: 'Konnektivität',
  cursors: 'Cursor',
  design: 'Design',
  development: 'Entwicklung',
  devices: 'Geräte',
  emoji: 'Emoji',
  files: 'Dateien',
  finance: 'Finanzen',
  'food-beverage': 'Essen & Trinken',
  gaming: 'Gaming',
  home: 'Zuhause',
  layout: 'Layout',
  logos: 'Logos',
  maps: 'Karten',
  math: 'Mathe',
  medical: 'Medizin',
  multimedia: 'Multimedia',
  nature: 'Natur',
  notifications: 'Benachrichtigungen',
  people: 'Personen',
  photography: 'Fotografie',
  science: 'Wissenschaft',
  security: 'Sicherheit',
  shapes: 'Formen',
  shopping: 'Shopping',
  social: 'Social',
  sports: 'Sport',
  sustainability: 'Nachhaltigkeit',
  text: 'Text',
  time: 'Zeit',
  tools: 'Tools',
  travel: 'Reisen',
  weather: 'Wetter',
  other: 'Sonstiges',
  Other: 'Sonstiges',
};

function startCaseKebab(input: string): string {
  return input
    .split('-')
    .filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ');
}

// Minimal “translation” layer for icon names.
// We keep it lightweight: kebab-case -> Start Case, plus a few common German terms.
const WORD_DE: Record<string, string> = {
  mail: 'E‑Mail',
  phone: 'Telefon',
  link: 'Link',
  user: 'Benutzer',
  users: 'Benutzer',
  message: 'Nachricht',
  messages: 'Nachrichten',
  calendar: 'Kalender',
  clock: 'Uhr',
  globe: 'Globus',
  map: 'Karte',
  pin: 'Pin',
  search: 'Suche',
};

function translateIconName(name: string): string {
  const parts = name.split('-').filter(Boolean);
  const translated = parts.map(
    (p) => WORD_DE[p] ?? p.charAt(0).toUpperCase() + p.slice(1),
  );
  return translated.join(' ');
}

export const iconPickerI18nDe: IconPickerI18n = {
  allIconsLabel: 'Alle Icons',
  emptyStateLabel: 'Kein Icon gefunden',
  getCategoryLabel: (key) => CATEGORY_DE[key] ?? startCaseKebab(key),
  getIconLabel: (icon: IconData) => translateIconName(icon.name),
};
